import CustomButton from "@components/buttons/CustomButton";
import { MerchantDropdown } from "@components/dropdowns/MerchantDropdown";
import GlobalTextInputField from "@components/inputs/GlobalTextInputField";
import SlidingPanel from "@components/sliders/SlidingPanel";
import { analyticsApis } from "@services/apis/Analytics";
import { useState } from "react";
import useSnackbarMessage from "../../../utils/HandleSuccessErrorSnackbars";

interface UpdatePaymentProofRequiredSliderProps {
  isOpen: boolean;
  onClose: () => void;
}

const PAYMENT_PROOF_OPTIONS = [
  { id: 1, name: "Enable" },
  { id: 0, name: "Disable" },
];

const UpdatePaymentProofRequiredSlider: React.FC<
  UpdatePaymentProofRequiredSliderProps
> = ({ isOpen, onClose }) => {
  const [merchantId, setMerchantId] = useState("");
  const [paymentProofRequired, setPaymentProofRequired] = useState<number>(1);
  const [loading, setLoading] = useState(false);
  const { handleSuccess, handleError } = useSnackbarMessage();

  const handleClose = () => {
    setMerchantId("");
    setPaymentProofRequired(1);
    onClose();
  };

  const isValid = () => {
    const id = Number(merchantId);
    return merchantId.trim() !== "" && !Number.isNaN(id) && id > 0;
  };

  const handleSubmit = async () => {
    if (!isValid()) return;

    try {
      setLoading(true);
      const response = await analyticsApis.updatePaymentProofPrimeRequired({
        merchantId: Number(merchantId),
        paymentProofRequired: paymentProofRequired as 0 | 1,
      });
      handleSuccess({
        message: response.msg || "Payment proof requirement updated.",
      });
      handleClose();
    } catch (error: any) {
      handleError({
        message:
          error?.response?.data?.msg ||
          "Failed to update payment proof requirement. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <SlidingPanel
      isOpen={isOpen}
      heading="Update Payment Proof Required"
      onClose={handleClose}
      onClickCross={handleClose}
      showConfirm={false}
      isSlider={false}
      widthDesktop="420px"
    >
      <div className="flex flex-col p-[16px] gap-[16px]">
        <GlobalTextInputField
          title="Merchant ID*"
          type="number"
          value={merchantId}
          onChange={(e) => setMerchantId(e.target.value)}
          placeholder="Enter merchant ID"
        />
        <MerchantDropdown
          listOfValues={PAYMENT_PROOF_OPTIONS}
          value={paymentProofRequired}
          onChange={(value) => setPaymentProofRequired(Number(value))}
          label="Payment Proof Required*"
          color="bg-page-body"
          expandedBorderColor="border-button-primary"
          baseColor="bg-page-body"
          borderColor="border-subtle"
        />
        <CustomButton
          text="UPDATE"
          isActive={isValid()}
          isButtonLoading={loading}
          onClick={handleSubmit}
        />
      </div>
    </SlidingPanel>
  );
};

export default UpdatePaymentProofRequiredSlider;
